var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-navigation',[_c('div',{class:_vm.$style.text},[_vm._v(" Недостаточно прав доступа для просмотра страницы ")])])}
var staticRenderFns = []

export { render, staticRenderFns }